<template>
    <div>
        <b-form>
            <div class="row">
                <div class="col-12">
                    <card-title-component :title="$t('contacts.addContact.title')"></card-title-component>
                    <div class="card-content">
                        <div class="row">
                            <div class="col">
                                <b-form-group id="firstname-form-group"
                                              class="o-label"
                                              :label="$t('contacts.addContact.firstname')"
                                              label-for="firstname-input">
                                    <b-form-input id="firstname-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localFirstname"
                                                  required
                                                  :placeholder="$t('contacts.addContact.firstname')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col">
                                <b-form-group id="name-form-group"
                                              class="o-label"
                                              :label="$t('contacts.addContact.name')"
                                              label-for="name-input">
                                    <b-form-input id="name-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localName"
                                                  required
                                                  :placeholder="$t('contacts.addContact.name')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <b-form-group id="phone-form-group"
                                              class="o-label"
                                              :label="$t('contacts.addContact.phone')"
                                              label-for="phone-input">
                                    <b-form-input id="phone-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localPhone"
                                                  required
                                                  :placeholder="$t('contacts.addContact.phone')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 button-div">
                    <b-button class="cancel-button o-button" v-on:click="cancel">
                        {{$t('contacts.addContact.cancelButton')}}
                    </b-button>
                    <b-button class="save-button o-button" v-on:click="addPet">
                        {{$t('contacts.addContact.saveButton')}}
                    </b-button>
                </div>
            </div>
        </b-form>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {
        CONTACTS_NAMESPACE,
        CONTACTS_ACTION_CREATE_CONTACT
    } from '../../store/modules/contacts-types'
    import CardTitleComponent from '../ui/card/CardTitleComponent'
    import {de, en} from 'vuejs-datepicker/dist/locale'

    export default {
        name: 'AddContact',
        components: {
            'card-title-component': CardTitleComponent
        },
        data () {
            return {
                localFirstname: '',
                localName: '',
                localPhone: ''
            }
        },
        methods: {
            ...mapActions(CONTACTS_NAMESPACE, {
                createContact: CONTACTS_ACTION_CREATE_CONTACT
            }),
            addPet () {
                this.createContact({
                    firstname: this.localFirstname,
                    name: this.localName,
                    phone: this.localPhone
                })
                this.localFirstname = ''
                this.localName = ''
                this.localPhone = ''
                this.$root.$emit('bv::hide::modal', 'add-contact-modal')
            },
            cancel () {
                this.$root.$emit('bv::hide::modal', 'add-contact-modal')
            },
            getLanguage () {
                if (this.$i18n.locale === 'en') {
                    return en
                } else {
                    return de
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .button-div {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/contacts/AddContactComponent.vue